import { Injectable } from "@angular/core";
@Injectable({providedIn: 'root'})
export class DownloadHelper {

  constructor() {

  }

  createCsvFromBlob(fileName: string, header: any, body: any, activeDocument: Document) {
    
    if (!body || body.length === 0) return;

    let csvContent = header + '\r\n' + body
    const blob = new Blob([csvContent], {type: 'text/csv'});
    
    // console.log(blob.text);

    const url = window.URL.createObjectURL(blob);
    const anchor = activeDocument.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    activeDocument.body.appendChild(anchor);
    anchor.click();
    activeDocument.body.removeChild(anchor);
    

  }
  
  // createDownloadFromBlob(res: any, activeDocument: Document) {
  // //   let fileName = '';

  // //   const disposition = res.headers.get('content-disposition');
  // //   const fileNameParserRegEx = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  // //   const matches = fileNameParserRegEx.exec(disposition);
  // //   fileName = matches[1].replace(/['"]/g, '');

  // //   const blob = new Blob([res.body], { type: 'text/csv' });
  // //   if (window.navigator.msSaveOrOpenBlob) {
  // //     window.navigator.msSaveBlob(blob, fileName);
  // //   } else {
  // //     const url = window.URL.createObjectURL(blob);
  // //     const anchor = activeDocument.createElement('a');
  // //     anchor.href = url;
  // //     anchor.download = fileName;
  // //     activeDocument.body.appendChild(anchor);
  // //     anchor.click();
  // //     activeDocument.body.removeChild(anchor);
  // //   }
  // }

  // createExcelDownloadFromBlob(res: any, activeDocument: Document) {
  // //   let fileName = '';

  // //   const disposition = res.headers.get('content-disposition');
  // //   const fileNameParserRegEx = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  // //   const matches = fileNameParserRegEx.exec(disposition);
  // //   fileName = matches[1].replace(/['"]/g, '');
  // //   const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

  // //   const blob = new Blob([res.body], { type: contentType });
  // //   if (window.navigator.msSaveOrOpenBlob) {
  // //     window.navigator.msSaveBlob(blob, fileName);
  // //   } else {
  // //     const url = window.URL.createObjectURL(blob);
  // //     const anchor = activeDocument.createElement('a');
  // //     anchor.href = url;
  // //     anchor.download = fileName;
  // //     activeDocument.body.appendChild(anchor);
  // //     anchor.click();
  // //     activeDocument.body.removeChild(anchor);
  // //   }
  // }
}
